<template>
  <FormRow :label="label">
    <div class="row">
      <div class="col-lg-3">
        <FormSelect v-if="editing" :options="filterTypeLookup" :value="filterTypeSetting" @input="filterTypeUpdated($event)" :field="`${field}Type`" />
        <FormStaticLabel v-if="!editing" class="font-weight-bold">{{filterTypeSetting | formatLookupName(filterTypeLookup)}}</FormStaticLabel>
      </div>
      <div class="col-lg-9">
        <FormMultiSelect v-show="editing && displayValue" :value="filterValueSetting" @input="filterValueUpdated($event)" :options="options" :field="`${field}Value`" />
        <FormStaticLabel v-if="!editing && displayValue">{{filterValueDisplay}}</FormStaticLabel>
      </div>
    </div>
  </FormRow>
</template>

<script>
import { FilterOptionTypes } from '@/store/types'

export default {
  name: 'DataUpdateFilter',
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    editing: Boolean,
    label: String,
    value: Object,
    options: Array,
    field: String
  },
  watch: {
    value: {
      immediate: true,
      handler: function(newVal, oldVal) {
        if(newVal) {
          this.filterTypeSetting = newVal.type
          this.filterValueSetting = newVal.valueList
          this.filterDescriptionSetting = newVal.descriptionList
        }
        if(this.filterTypeSetting == null || this.filterTypeSetting == '')
          this.filterTypeSetting = FilterOptionTypes.all
      }
    }
  },
  computed: {
    displayValue() {
      return this.filterTypeSetting != FilterOptionTypes.all
    },
    filterValueDisplay() {
      if(!this.filterValueSetting)
        return ''
      return this.filterValueSetting
      .map(value => {
        let lookupOpt = this.options.find(opt => opt.value == value)
        if(lookupOpt)
          return lookupOpt.name
        return ''
      })
      .join(', ')
    }
  },
  data() {
    return {
      filterTypeSetting: FilterOptionTypes.all,
      filterValueSetting: [],
      filterDescriptionSetting: [],
      filterTypeLookup: [
        { value: FilterOptionTypes.all, name: 'All' },
        { value: FilterOptionTypes.include, name: 'Include' },
        { value: FilterOptionTypes.exclude, name: 'Exclude' },
      ],
    }
  },
  methods: {
    filterTypeUpdated(type) {
      this.filterTypeSetting = type
      this.$emit('update', {
        type: this.filterTypeSetting,
        valueList: this.filterValueSetting,
        descriptionList: this.filterDescriptionSetting
      })
    },
    filterValueUpdated(value) {
      this.filterValueSetting = value
      let optionList = this.options || []
      this.filterDescriptionSetting = (value || []).map(item => {
        let optionItem = optionList.find(option => item == option.value)
        if(optionItem)
          return optionItem.name
        return ''
      })

      this.$emit('update', {
        type: this.filterTypeSetting,
        valueList: this.filterValueSetting,
        descriptionList: this.filterDescriptionSetting
      })
    }
  }

}
</script>